import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ModalType } from '../simple-modal/models/simple-modal.interfaces';
import { FooterInformation } from './models/footer-slim.interfaces';

// TODO(sergio, padma): validate the remove of  [focusOnModal]="showModal" on the template

@Component({
  selector: 'idp-footer-slim',
  templateUrl: './footer-slim.component.html',
  styleUrls: ['./footer-slim.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterSlimComponent {
  @Input() content: FooterInformation = {
    footer: {
      search: { placeHolder: '' },
      populartopics: { heading: '' },
      info: { copyright: '', disclaimer1: '', disclaimer2: '' },
      socialIcons: null,
      feedback: {},
      countrylanguage: {
        id: '',
        defaultCountry: '',
        headingText: '',
        country: '',
        language: '',
        done: '',
        supportedCountry: ''
      }
    },
    accessibilityPopUp: {
      primaryLabel: '',
      secondaryLabel: '',
      popupTitle: '',
      popupDesc: '',
      popupQuestion: ''
    }
  };

  previousActiveElement: Element | null = null;
  showModal = false;
  openExternalSite = '';
  axContent = '';

  modalType = ModalType.Default;

  /** To open external Site Modal for Social icons in footer */
  openModal($event: Event, iconLink: string): void {
    if ($event) {
      this.previousActiveElement = document.activeElement;
      this.openExternalSite = iconLink;
      this.axContent =
        this.content.accessibilityPopUp.popupDesc +
        '<br><br>' +
        this.content.accessibilityPopUp.popupQuestion;
      this.showModal = true;
    }
  }

  /** To close the Modal, triggers when No button is clicked clicked outside Modal */
  closeModal(): void {
    this.showModal = false;
    if (document.body.contains(this.previousActiveElement)) {
      const id = (this.previousActiveElement as Element).id;
      const elementFocus = document.getElementById(id);
      if (elementFocus) {
        elementFocus.focus();
      }
    }
  }

  /** To open the link for the external social site */
  submitModal(): void {
    if (this.openExternalSite) {
      this.showModal = false;
      window.open(this.openExternalSite, '_blank');
    }
  }

  /** To add aria-label for button */
  getSubmitButtonLabel(label: string): string {
    return label ? `${label} opens in a new window` : label;
  }
}
